/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface SessionReferencesAssignmentDto
 */
export interface SessionReferencesAssignmentDto {

    /**
     * Assignment identifier
     *
     * @type {number}
     * @memberof SessionReferencesAssignmentDto
     */
    id: number;

    /**
     * Display name of the member the assignment belongs to
     *
     * @type {string}
     * @memberof SessionReferencesAssignmentDto
     * @example Mario Rossi
     */
    member: string;

    /**
     * The member, for linking
     *
     * @type {JoinEntityDto}
     * @memberof SessionReferencesAssignmentDto
     */
    memberRef: JoinEntityDto;

    /**
     * Title of the therapy the assignment was created from
     *
     * @type {string}
     * @memberof SessionReferencesAssignmentDto
     * @example Riabilitazione spalla — fase 1
     */
    therapy: string;

    /**
     * Whether the assignment was created by the practitioner requesting the edit. When false, confirming changes another practitioner’s work.
     *
     * @type {boolean}
     * @memberof SessionReferencesAssignmentDto
     */
    own: boolean;

    /**
     * How many of its events would be rewritten
     *
     * @type {number}
     * @memberof SessionReferencesAssignmentDto
     * @example 4
     */
    events: number;

    /**
     * Scheduled date of the earliest event that would be rewritten (ISO 8601)
     *
     * @type {string}
     * @memberof SessionReferencesAssignmentDto
     */
    firstEventAt: string | null;

    /**
     * Scheduled date of the latest event that would be rewritten (ISO 8601)
     *
     * @type {string}
     * @memberof SessionReferencesAssignmentDto
     */
    lastEventAt: string | null;
}
